export const SEARCH_PARAMS = {
  WORD: 'word',
  OFFER_ID: 'offerId',
  CATEGORY_IDS: 'categoryIds',
  CATEGORIES: 'categories',
  SHOW_CATEGORIES_MODAL: 'showCategoriesModal',
  PARTNERS: 'partner',
  SEARCH: 'searchBarOpen',
  SEARCH_TERM_PARTNER_ID: 'withPartnerId',
  SHOW_MAP_CATEGORIES: 'mapCategories',
  AUTO_LOGIN: 'autoLogin',
  TOKEN: 'token',
  LOCATION: 'location',
  LOCATIONS_MODAL: 'locationsModal',
  SHOW_PRIVACY_MODAL: 'privacyModal',
  SHOW_SHARE_OPTIONS: 'shareOptions',
  SHOW_OFFER_JUST_SAVED_MODAL: 'saved',
  SHOW_STORE_JUST_SAVED_MODAL: 'store_saved',
  REFUSED_GIFT: 'refused_gift',
  PROMPT_LOGIN: 'promptLogin',
  CODE: 'code',
  STATE: 'state',
  REDIRECTED: 'redirected',
  SHOW_PARTNER_MODAL: 'showPartnerModal',
  MENU: 'menuOpen',
  HIDE_HEADER_FOOTER: 'hideHeaderFooter',
  SORT: 'sort',
  MIN_DISCOUNT: 'minDiscount',
  OPENED_FROM: 'openedFrom',
  QUIZ_AD_ID: 'quizAdId'
} as const;
